import styled from 'styled-components/macro';
import { Box, Flex, Container } from '@podiumhq/design-system';

import { WiggleAnimation } from 'styles';

const SelectPlanLoadingGhostView = ({ isDormant, isMobile }) => {
  const ghostPlanStyles = {
    height: isMobile ? '230px' : '545px',
    marginTop: isMobile ? '24px' : '72px',
    width: '360px',
  };
  const ghostTitleStyles = {
    height: '72px',
    width: isMobile ? '100%' : '490px',
  };

  return (
    <WiggleAnimation data-testid="select-plan-loading-ghost-view">
      <Box
        margin={isDormant ? '0' : '0 auto'}
        maxWidth="1440px"
        padding={isMobile ? '24px' : isDormant ? '0' : '20px 40px 24px 40px'}
      >
        <Container maxW="container.xl">
          {!isDormant && <GhostState {...ghostTitleStyles} />}

          <Flex
            align={isMobile ? 'center' : 'flex-end'}
            boxSizing="border-box"
            direction={isMobile ? 'column' : 'row'}
            justify="space-between"
            maxWidth="100%"
          >
            <GhostState {...ghostPlanStyles} />
            <GhostState {...ghostPlanStyles} />
            <GhostState {...ghostPlanStyles} />
          </Flex>

          <GhostState {...ghostButtonStyles} />
        </Container>
      </Box>
    </WiggleAnimation>
  );
};

const GhostState = styled(Box)`
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation: placeHolderShimmer 1.5s linear;
  animation-iteration-count: infinite;
  background-size: 200% auto;
  background: #f4f6f9;
  background: linear-gradient(to right, #f4f6f9 8%, #eeeeee 18%, #f4f6f9 33%);
  border-radius: 8px;
  margin: 4px 0;
`;

const ghostButtonStyles = {
  height: 40,
  margin: '46px auto 0 auto',
  width: 281,
};

export default SelectPlanLoadingGhostView;
